
export enum Tabs {
  REWARDS = 'REWARDS',
  WAYS_TO_EARN = 'WAYS_TO_EARN',
  TRANSACTION_HISTORY = 'TRANSACTION_HISTORY',
}

export enum RewardType {}
